import React from 'react';
import { MailIcon, PhoneIcon } from 'lucide-react';
import { company, modules, offer } from '../../data/offer';
import { Section } from './Section';
const formatPrice = (value: number) => `€ ${value.toLocaleString('nl-NL')}`.replace(/\s/g, '\u00a0');
const total = modules.reduce((sum, item) => sum + item.price, 0);
export function Investment() {
  return <Section index="07" label="Investering" title="Prijsoverzicht" intro="Alle onderdelen samen. Je kunt ook met een deel starten en later uitbreiden — de onderdelen zijn op elkaar gebouwd." data-id="element-12" data-mp="ibpakso769lz">
      <dl className="divide-y divide-line border-y border-line" data-id="element-13" data-mp="3kf7unvdhmec">
        {modules.map(item => <div key={item.id} className="flex items-baseline justify-between gap-6 py-4" data-id="element-14" data-mp="3vor9n97l9r4t">
            <dt className="text-[15px] text-white/80" data-id="element-15" data-mp="3qpekght8w7z2">
              {item.title}
              <span className="ml-3 text-xs uppercase tracking-[0.14em] text-white/35" data-id="element-16" data-mp="3qrhct8hved6y">
                {item.duration}
              </span>
            </dt>
            <dd className="whitespace-nowrap text-[15px] font-semibold text-white" data-id="element-17" data-mp="1kosbcd3e4rt7">
              {formatPrice(item.price)}
            </dd>
          </div>)}

        <div className="flex flex-wrap items-baseline justify-between gap-4 py-6" data-id="element-18" data-mp="1bpf31nr069a2">
          <dt className="text-lg font-semibold tracking-tight text-white" data-id="element-19" data-mp="1go9icfprhfpf">
            Totaal compleet pakket
          </dt>
          <dd className="whitespace-nowrap text-4xl font-semibold tracking-tight text-white md:text-5xl" data-id="element-20" data-mp="24day6o0xbt4q">
            {formatPrice(total)}
          </dd>
        </div>
      </dl>

      <p className="mt-4 text-sm text-white/45" data-id="element-21" data-mp="1ufmz5lwabzgr">
        {offer.priceNote} · 50% bij akkoord, 50% bij livegang · training van 1 uur
        en 14 dagen nazorg inbegrepen
      </p>

      <div className="mt-10 flex flex-wrap gap-3" data-id="element-22" data-mp="1zgu7bm2cb0ny">
        <a href={`mailto:${company.email}?subject=Akkoord%20offerte%20${encodeURIComponent(offer.subject)}`} className="inline-flex items-center gap-2 rounded-full bg-accent px-5 py-3 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:bg-accent-dark" data-id="element-23" data-mp="izg7ram7tfwy">
          <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-24" data-mp="3w2jzcg8ho024" />
          Akkoord geven
        </a>
        <a href={`tel:${company.phoneHref}`} className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-line px-5 py-3 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:border-white/30 hover:bg-white/5" data-id="element-25" data-mp="3r9ikg88a80ij">
          <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-26" data-mp="3cc88kxrq8sma" />
          {company.phone}
        </a>
      </div>
    </Section>;
}